import { usePage } from "@inertiajs/react";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import Container from "hardcover-ui/components/Container";
import AuthorHeader from "components/authors/AuthorHeader";
import AuthorTabs from "components/authors/AuthorTabs";
import { AuthorSeriesIndexPageProps } from "./index.props";
import SeriesGroup from "components/BookGroup/groups/SeriesGroup";
import Callout from "hardcover-ui/components/Callout";
import Text from "hardcover-ui/components/Text";
import AuthorSeriesHeader from "components/BookGroup/headers/AuthorSeriesHeader";

function AuthorSeriesIndexPage() {
  const { author, series } = usePage<AuthorSeriesIndexPageProps>().props;

  return (
    <>
      <Container variant="layout" className="mb-4">
        <AuthorHeader author={author} />
        <AuthorTabs author={author} />

        <Callout variant="secondary" size="md" className="mt-4">
          <Text variant="secondary" className="italic">
            Authorship percentage indicates primary author status - excluding introductions, forewards and other contributions.
          </Text>
        </Callout>

        <div className="space-y-12 mt-8 divide-y divide-gray-300 dark:divide-gray-600">
          {series.map((serie, index) => (
            <div className={index > 0 ? "pt-8" : ""} key={`series-${serie.id}`}>
              <SeriesGroup series={serie} size="md" header={AuthorSeriesHeader} />
            </div>
          ))}
        </div>
      </Container>
    </>
  );
}

AuthorSeriesIndexPage.layout = DefaultLayoutWrapper;
export default AuthorSeriesIndexPage;